module.exports = __webpack_public_path__ + "img/21.f124d879.jpg";